// Libraries
import React from 'react';

// Supermove
import {Icon, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useQuery, useResponsive, useToast} from '@supermove/hooks';
import {LeadProviderEndpoint} from '@supermove/models';

import DrawerWithAction from '@shared/design/components/Drawer/DrawerWithAction';
import FieldInput from '@shared/design/components/Field/FieldInput';
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import useUpdateLeadProviderEndpointMutation from 'modules/Organization/Settings/Company/components/LeadProvider/useUpdateLeadProviderEndpointMutation';

const Container = Styled.View``;

const UpdateLeadProviderEndpointUrlDrawer = ({
  endpoint,
  isOpen,
  handleClose,
  refetch,
}: {
  endpoint: LeadProviderEndpoint;
  isOpen: boolean;
  handleClose: () => void;
  refetch: ReturnType<typeof useQuery>['refetch'];
}) => {
  const responsive = useResponsive();
  const successToast = useToast({
    ToastComponent: SuccessToast,
    message: 'Changes saved.',
  });

  const {form, submitting, handleSubmit} = useUpdateLeadProviderEndpointMutation({
    endpoint,
    onSuccess: () => {
      successToast.handleToast();
      form.resetForm();
      handleClose();
      refetch();
    },
    onError: (errors) => {
      console.error({errors});
    },
  });

  return (
    <DrawerWithAction
      isOpen={isOpen}
      handleClose={handleClose}
      headerText={'Edit Zapier URL'}
      primaryActionText={'Save'}
      primaryActionIcon={Icon.Check}
      isSubmitting={submitting}
      isDisabled={!form.values.updateLeadProviderEndpointForm.customFields?.url}
      handleSubmit={handleSubmit}
    >
      <Container responsive={responsive}>
        <FieldInput
          {...form}
          name={`updateLeadProviderEndpointForm.customFields.url`}
          label={'Zapier URL'}
          input={{
            placeholder: 'Enter Zapier URL',
            style: {width: '100%'},
          }}
          isResponsive
          isRequired
        />
      </Container>
    </DrawerWithAction>
  );
};

UpdateLeadProviderEndpointUrlDrawer.fragment = gql`
  ${useUpdateLeadProviderEndpointMutation.fragment}
  fragment UpdateLeadProviderEndpointUrlDrawer on LeadProviderEndpoint {
    ...useUpdateLeadProviderEndpointMutation
  }
`;

export default UpdateLeadProviderEndpointUrlDrawer;
